import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30 * 1000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['authorization'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['authorization'] = 'Bearer ' + getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === undefined) {
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      return res
    } else {
      // relogin
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    const status = error.response.status || 0
    switch (status) {
      case 400:
        if (error.response.data.code == 100401) {
          store.dispatch('user/logout')
        }
        Message({
          message: error.response.data.message,
          type: 'error',
          duration: 5 * 1000
        })
        if (error.response.data.code == 100009) {
          return Promise.reject(new Error(error.response.data.code))
        }
        if (error.response.data.code == 100010) {
          return Promise.reject(new Error(error.response.data.code))
        }
        break
      case 422:
        Message({
          message: '请输入完整信息',
          type: 'error',
          duration: 5 * 1000
        })
        break
      case 403:
        router.push('/my')
        setTimeout(() => {
          window.location.reload()
        }, 1000)
        break
      case 413:
        Message({
          message: '上传附件过大，请重新上传',
          type: 'error',
          duration: 5 * 1000
        })
        break
      case 500:
        Message({
          message: '系统错误，请联系管理员',
          type: 'error',
          duration: 5 * 1000
        })
        break
      default:
        console.log(error.response)
        break
    }
    return Promise.reject(error)
  }
)

export default service
